import type { PorociloNaVoljo, VrstaPorocila } from '@koda/shared';

/**
 * Zavihek s povezavo »Izvozi vsa poročila«: prvi zavihek s tabelami.
 *
 * Povezava je samo na enem zavihku, sicer bi bila nad vsako tabelo dva gumba.
 * Kazalniki so lahko prvi zavihek (`reference/moduli.csv`), izvoza tabel pa
 * nimajo, zato bi povezava s pravilom »prvi zavihek« izginila povsod.
 */
export function zavihekIzvozaVseh(naVoljo: readonly Pick<PorociloNaVoljo, 'vrsta'>[]): VrstaPorocila {
  return naVoljo.find((p) => p.vrsta !== 'kazalniki')?.vrsta ?? 'hitri';
}
